export default {
  app: {
    title: 'Fall Detection System',
    titleShort: 'Fall Detection',
  },
  canvas: {
    origin: 'O',
    axisX: 'X (m)',
    axisY: 'Y (m)',
  },
  nav: {
    trackMonitor: 'Alarm Monitor',
    activityOverview: 'Activity',
    roomLayout: 'Room Layout',
    activityShort: 'Overview',
    roomShort: 'Room',
    paramConfig: 'Parameters',
    track: 'Alarm',
    connect: 'Connect',
    config: 'Config',
  },
  install: {
    mode: 'Mounting:',
    top: 'Ceiling',
    side: 'Wall',
  },
  track: {
    visualization: 'Alarm Map',
    showTrackId: 'Show track ID',
    resetViewTitle: 'Reset view (drag to pan, wheel to zoom)',
    resetViewTitleShort: 'Reset view',
    reset: 'Reset',
    count: 'Count',
    deviceOnlineShort: 'Device {state}',
    online: 'online',
    offline: 'offline',
    checking: 'checking',
    trackIdOnOff: 'Track ID {state}',
    on: 'On',
    off: 'Off',
    poseStand: 'Standing',
    poseWalk: 'Walking',
    poseSit: 'Sitting',
    poseLie: 'Lying',
    poseUnknown: 'Unknown',
    logToggle: 'Show / hide log',
    sidebarToggle: 'Show / hide sidebar',
  },
  connection: {
    mqttTitle: 'MQTT connection',
    deviceMac: 'Device serial',
    deviceMacColon: 'Device serial:',
    subscribeTopic: 'Subscribe topic',
    subscribeTopicColon: 'Subscribe topic:',
    configTopicColon: 'Config topic:',
    topicPlaceholder: 'Enter 20-char serial starting with D',
    configTopicPlaceholder: 'radar/falldetect/Dxxxxxxxxxxxxxxxxxxx/cmd',
    connect: 'Connect',
    disconnect: 'Disconnect',
    connecting: 'Connecting...',
    connectingShort: 'Connecting',
  },
  common: {
    custom: 'Custom',
    dash: '-',
  },
  status: {
    title: 'Connection status',
    connected: 'Connected',
    disconnected: 'Disconnected',
    appServerConnected: 'App connected to server',
    appServerDisconnected: 'App not connected to server',
    appServerConnecting: 'App connecting to server…',
    appServerConnectedShort: 'App online',
    appServerDisconnectedShort: 'App offline',
    appServerConnectingShort: 'App connecting…',
    deviceOnline: 'Device online:',
    deviceOnlineLabel: 'Device online',
    deviceOfflineLabel: 'Device offline',
    deviceChecking: 'Checking…',
    hardwareVersion: 'Hardware version:',
    refreshHwVersion: 'Refresh HW version',
    writeHwVersionTest: 'Write HW version (test)',
    hwVersionInputPlaceholder: 'e.g. v0.1.2.3',
    online: 'Yes',
    offline: 'No',
    framesReceived: 'Frames received:',
    frameSeq: 'Frame seq:',
    framesLine: 'Frames {frames} · Seq {seq}',
    personCount: 'People count',
  },
  config: {
    title: 'Parameters',
    configTopic: 'Config topic',
    algoParams: 'Algorithm parameters',
    algoParamsShort: 'Algorithm',
    radarHeight: 'Radar height (m):',
    downtAngle: 'Depression angle (deg):',
    downtPresetSide: 'Side 30°',
    downtPresetTop: 'Top 90°',
    downtCustomHint: 'Or enter a custom angle',
    radarRoll: 'Radar roll (deg):',
    radarAzimuth: 'Radar azimuth (deg):',
    zFallMax: 'Fall height threshold (m):',
    fallAlarmWaitS: 'Judgment time (s):',
    microAccumMaxCnt: 'Micro accumulation (frames):',
    heightShort: 'Height (m)',
    downtShort: 'Tilt (°)',
    rollShort: 'Roll (°)',
    azimuthShort: 'Azimuth (°)',
    zFallMaxShort: 'Fall thr (m)',
    fallAlarmWaitSShort: 'Judge time (s)',
    microAccumMaxCntShort: 'Micro accum (fr)',
    otherParams: 'Other',
    collapseOther: 'Hide',
    reportFormat: 'Data output format:',
    reportFormatShort: 'Data output format',
    dataOutputFormat: 'Data output format:',
    dataOutputFormatShort: 'Data output format',
    applyReportFormat: 'Apply format',
    reportFormatCaution: 'Change carefully: this switches track/alert data output shape. Use Set params to apply, Get params to refresh. Settings still use binary commands; report accepts both TLV and JSON.',
    dataOutputFormatCaution: 'Change carefully: this switches track/alert data output shape. Use Set params to apply, Get params to refresh from the device.',
    reportFormatNeedVersion: 'Firmware below {need}; data output format is unavailable',
    dataOutputFormatNeedVersion: 'Firmware below {need}; data output format is unavailable',
    dataOutputFormatCurrent: 'Current: {format}',
    sceneMode: 'Scene mode:',
    sceneModeShort: 'Scene mode',
    sceneModeGeneral: 'General',
    sceneModeShower: 'Shower room',
    sceneModeCurrent: 'Current: {scene}',
    sceneModeCaution: 'Use with caution: switching changes the algorithm scene (shower room uses its own tracking/confirmation gates). Tap Set parameters to apply, or Get parameters to sync the current device value.',
    sceneModeNeedVersion: 'Firmware below {need} does not support scene switching',
    outputOn: 'On',
    outputOff: 'Off',
    trackOutput: 'Track output:',
    trackOutputShort: 'Track output',
    trackOutputCurrent: 'Current: {state}',
    trackOutputCaution: 'Use with caution: when off, the device stops reporting track frames and keeps only fall/zone alarms. Tap Set parameters to apply, or Get parameters to sync the current device value.',
    trackOutputNeedVersion: 'Firmware below {need} does not support track output switching',
    alarmOutput: 'Alarm output:',
    alarmOutputShort: 'Alarm output',
    alarmOutputCurrent: 'Current: {state}',
    alarmOutputCaution: 'Use with caution: when off, the device stops reporting fall/zone alarm frames and keeps only tracks. Tap Set parameters to apply, or Get parameters to sync the current device value.',
    alarmOutputNeedVersion: 'Firmware below {need} does not support alarm output switching',
    meter: 'm',
    degree: 'deg',
    frameUnit: 'frames',
    secondUnit: 's',
    startSession: 'Start session',
    endSession: 'End session',
    getParams: 'Read params',
    setParams: 'Write params',
    getParamsGetting: 'Reading…',
    getParamsSuccess: 'Updated',
    getParamsFail: 'Read failed',
    setParamsSetting: 'Writing…',
    setParamsSuccess: 'Saved',
    setParamsFail: 'Update failed',
    paramsNeedConnect: 'Connect MQTT before configuring parameters',
    paramsNeedFetch: 'Device parameters not loaded yet. Tap Read params first',
    getDebugParams: 'Read DEBUG',
    setDebugParams: 'Write DEBUG',
    sessionStatus: 'Session:',
    sessionStarted: 'Active',
    sessionNotStarted: 'Inactive',
    sessionLabel: 'Session:',
    lastOperation: 'Last action:',
    responseTitle: 'Config log',
    showLogPanel: 'Show log',
    hideLogPanel: 'Hide log',
    clearLogs: 'Clear log',
    clear: 'Clear',
    versionUpgradeTitle: 'Version & Upgrade',
    deviceVersion: 'Current version',
    latestVersion: 'Latest version',
    upgradeProgress: 'Upgrade progress',
    checkUpdate: 'Check update',
    upgradeNow: 'Start upgrade',
  },
  upgrade: {
    noVersion: 'No version',
    noVersionHint: 'No valid device version read; upgrade disabled',
    serverVersion: 'Server version',
    checking: 'Checking for updates…',
    readingVersion: 'Reading device version…',
    deviceVersionOk: 'Device version: {version}',
    serverVersionOk: 'Server version: {version}',
    readVersionFailed: 'Read device version failed: {message}',
    errDeviceOffline: 'Device offline: no live/report within 30s',
    errUnsupportedDeviceType: 'Only fall-detect serial numbers (D…) are supported',
    errBadServerVersion: 'Invalid server version: {name}',
    resultNeedUpdate: 'Update available',
    resultUpToDate: 'Already up to date',
    resultNoServer: 'No firmware on server',
    noServerVersion: 'N/A',
    compareLog: 'Device {device} / Server {server}',
    checkFailed: 'Check update failed: {message}',
    cannotUpgradeNoVersion: 'No valid device version; upgrade disabled',
    cannotUpgrade: 'Cannot upgrade now (check update and ensure device online)',
    noHwVersion: 'Not read',
    readingHwVersion: 'Reading hardware version…',
    deviceHwVersionOk: 'Hardware version: {version}',
    readHwVersionFailed: 'Failed to read hardware version: {message}',
    errBadHwVersion: 'Invalid hardware version format: {name}',
    err4gNotSupported: '4G devices cannot be upgraded via the web page yet',
    errWifiSerialRequired: 'Only WiFi devices support web upgrade (3rd serial character must be W)',
    errInvalidSerialForUpgrade: 'Web upgrade requires a 20-character WiFi device serial number',
    tryResume: 'Resume interrupted upgrade (continue from last progress)',
    phaseDownload: 'Download',
    phaseFlash: 'Flash',
    phaseJump: 'Restarting device…',
    phaseVersion: 'Version write',
    serverFirmwareFile: 'Server firmware: {suffix} ({url})',
    serverFirmwareBadSuffix: 'Server firmware URL must end with .hex or .bin: {url}',
    firmwareParsed: 'Firmware verified: {desc}',
    starting: 'Starting firmware upgrade…',
    success: 'Upgrade complete, device version: {version}',
    failed: 'Upgrade failed: {message}',
    failedStage: 'Upgrade failed at stage: {stage}',
    failedStageDetail: 'Upgrade failed at stage: {stage} ({detail})',
    phaseHttpDownload: 'Downloading firmware from server…',
    phaseIapUpload: 'Uploading firmware to device via MQTT…',
    phaseWaitLive: 'Flash done, waiting for device to come online…',
    errNoLiveAfterCommit: 'COMMIT OK but no new live heartbeat',
    liveOkStartVersion: '[V2] Device online, writing version',
    opCheckUpdate: 'Check update',
    opReadVersion: 'Read device version',
    opUpgradeDone: 'Firmware upgrade',
  },
  history: {
    title: 'Alarm History',
    titleShort: 'History',
    show: 'Show history',
    hide: 'Hide history',
    close: 'Close history',
    clear: 'Clear history',
    empty: 'No alarms yet',
  },
  activity: {
    statusTitle: 'Activity',
    statusActive: 'Active',
    statusInactive: 'No activity',
    statusAbsent: 'No person',
    statusPaused: 'No person',
    statusHint: 'Tracks present: active. No tracks: no activity immediately. Continuous no tracks beyond threshold: no person',
    timeoutLabel: 'No-person threshold',
    timeoutUnit: 'min',
    position: 'Position',
    noFallAlert: 'No fall alarm',
    roomPreview: 'Room preview',
    roomPreview3d: 'Room 3D view',
    view3d: '3D',
    view2d: '2D',
    view3dHint: 'Drag to orbit · scroll to zoom · blue=radar at mount height',
    view3dLoadFail: 'Failed to load 3D assets. Deploy full dist/assets (including RoomSpace3DCanvas-*.js), or rebuild with VITE_BASE=/',
    view3dRetry: 'Retry',
    posCenter: 'Center of room',
    posFront: 'Front of room',
    posBack: 'Back of room',
    posLeft: 'Left side',
    posRight: 'Right side',
    posFrontLeft: 'Front left',
    posFrontRight: 'Front right',
    posBackLeft: 'Back left',
    posBackRight: 'Back right',
  },
  room: {
    title: 'Room & radar layout',
    nameLabel: 'Room name',
    namePlaceholder: 'e.g. Master bedroom, Living room',
    width: 'Room width',
    depth: 'Room depth',
    radarX: 'Radar X',
    radarY: 'Radar Y',
    dragHint: 'Drag handles to resize the room and move the radar; drag the forward rotate handle to set azimuth (synced with Config); click zones to move or resize',
    layoutReadout: 'W {width} m × D {depth} m · Radar X {radarX} / Y {radarY} m',
    azimuthReadout: 'Azimuth {azimuth}°',
    installFromDevice: 'Install: {mode} (from device params)',
    saveLayout: 'Save',
    zonesEmptyShort: 'No zones',
    zonesTitle: 'Functional zones',
    zonesHint: 'Click a rectangle on the canvas to select; drag to move, drag corners to resize; edit type and enable below',
    zonesEmpty: 'No zones yet. Click "Add zone" to create one.',
    addZone: 'Add zone',
    removeZone: 'Remove selected',
    loadParams: 'Load from device',
    loadParamsGetting: 'Loading…',
    loadParamsSuccess: 'Updated',
    loadParamsFail: 'Load failed',
    saveLayoutSetting: 'Saving…',
    saveLayoutSuccess: 'Saved',
    saveLayoutFail: 'Save failed',
    writeZonesToDevice: 'Save',
    loadOk: 'Loaded successfully',
    loadFail: 'Load failed',
    saveOk: 'Saved successfully',
    saveFail: 'Save failed',
    funcZonesFwHint: 'Zones require firmware v0.1.6.0 or newer',
    funcZonesFwCurrent: 'Current {version}',
    funcZonesFwTooOld: 'Version {version} is too old for zone R/W',
    zoneType: 'Type',
    zoneEnabled: 'Enabled',
    zoneDisabled: 'Disabled',
    zoneType0: 'Mask',
    zoneType1: 'Dwell',
    zoneType2: 'Intrusion',
    zoneType3: 'Multi-person',
    zoneType4: 'Leave',
    zoneType5: 'Leave room',
  },
  alarm: {
    title: 'Fall Alarm',
    zoneTitle: 'Zone alarm',
    zoneId: 'Zone ID',
    type: 'Alarm Type',
    x: 'x',
    y: 'y',
    time: 'Time',
    typeFast: 'Fast Fall',
    typeSlow: 'Slow Fall',
    typeVerySlow: 'Very Slow Fall',
    typeUnknown: 'Unknown ({type})',
  },
  log: {
    sidebarTitle: 'Log',
    sidebarTitleShort: 'Log',
    clickToCollapse: 'Click to collapse',
    showFrameLogs: 'Log frame reception',
    clearLogs: 'Clear log',
  },
  ack: {
    success: 'Success',
    invalid_param: 'Invalid parameter',
    invalid_state: 'Invalid state (start session first)',
    invalid_length: 'Invalid length',
    crc_error: 'CRC error',
    buffer_overflow: 'Buffer overflow',
    decode_error: 'Decode error',
    invalid_status: 'Invalid status code ({status})',
    unknown_status: 'Unknown status ({hex})',
  },
  tlv: {
    headerTooShort: 'Data too short for frame header',
    badMagic: 'Bad header, expected 0xAA 0x55',
    frameTypeTooShort: 'Data too short for frame type',
    frameLenTooShort: 'Data too short for frame length',
    crcTooShort: 'Data too short for CRC',
    extDataInsufficient: 'Extended data too short: remaining={remaining}',
    base64Failed: 'Base64 decode failed: {message}',
    unsupportedFormat: 'Unsupported message format',
    unknown: 'Unknown reason',
  },
  msg: {
    parseFrameFailed: 'Failed to parse frame: {reason}',
    previewPart: ' Preview: {preview}',
    handleError: 'Message handling error: {message}',
    errNeedConnectionInfo: 'Error: fill in connection details',
    clientId: 'Client ID: {id}',
    connectingBroker: 'Connecting to MQTT broker: {url}...',
    mqttConnected: 'MQTT connected',
    subscribeTopicFailed: 'Subscribe failed: {message}',
    subscribedTopic: 'Subscribed: {topic}',
    subscribeLiveFailed: 'Subscribe live topic failed: {message}',
    subscribedLive: 'Subscribed live: {topic}',
    mqttError: 'MQTT error: {message}',
    reconnecting: 'Reconnecting...',
    reconnectSkipAutoFetch: 'Reconnected to server, skipped auto parameter fetch (use Get parameters if needed)',
    forceReconnect: 'Link issue detected, reconnecting to server ({reason})',
    connectFailed: 'Connection failed: {message}',
    disconnected: 'MQTT disconnected',
  },
  cfg: {
    decodeFailed: 'Failed to decode config response',
    unsupportedFormat: 'Unsupported config response format',
    parseResponseFailed: 'Failed to parse config response: {hex}',
    receivedConfigHex: 'Config response data: {hex}',
    ackReceived: 'ACK: cmd={cmd}, status={status}',
    sessionStarted: 'Session started',
    sessionEnded: 'Session ended',
    getParamsOk:
      'Parameters read: height={h} m, tilt={d}°, roll={r}°, azimuth={a}°, fall_th={z} m, judge={w}s, micro={m} fr',
    setParamsOk:
      'Parameters written: height={h} m, tilt={d}°, roll={r}°, azimuth={a}°, fall_th={z} m, judge={w}s, micro={m} fr',
    sendingGetAllParams: 'Reading algorithm params and micro accumulation...',
    sendingSetAllParams:
      'Writing params: height={h} m, tilt={d}°, roll={r}°, azimuth={a}°, fall_th={z} m, judge={w}s, micro={m} fr',
    fallAlarmWaitWriteSkipLegacy: 'Legacy 20-byte ALGO block; judgment time not written',
    fallAlarmWaitRetryLegacy: '24-byte ALGO rejected; retrying legacy 20-byte block',
    sendingGetFuncZones: 'Reading functional zones…',
    sendingSetFuncZones: 'Writing functional zones…',
    getFuncZonesOk: 'Zones read OK: {count}',
    getFuncZonesEmptyKeepLocal: 'Device returned no zones; keeping current {count} (may all be disabled)',
    setFuncZonesOk: 'Zones written OK: {count}',
    getFuncZonesFailed: 'Failed to read zones',
    setFuncZonesFailed: 'Failed to write zones',
    getFuncZonesParseFail: 'Failed to parse zones response',
    buildGetFuncZonesFail: 'Failed to build zones GET',
    buildSetFuncZonesFail: 'Failed to build zones SET',
    roomConfigSkippedLowVersion: 'Firmware {version} < {need}; skip room param sync',
    buildSetRoomConfigFail: 'Failed to build room config SET',
    sendingSetRoomConfig: 'Writing room size / radar position…',
    setRoomConfigOk: 'Room size / radar position written',
    buildGetRoomConfigFail: 'Failed to build room config GET',
    getRoomConfigParseFail: 'Failed to parse room config response',
    getRoomConfigOk: 'Room config read OK: {w} m × {d} m',
    funcZonesSkippedLowVersion: 'Firmware {version} < {need}; skip zone sync',
    reportFormatSkippedLowVersion: 'Firmware {version} < {need}; cannot switch output format',
    buildGetReportFormatFail: 'Failed to build get report-format command',
    buildSetReportFormatFail: 'Failed to build set report-format command',
    sendingSetReportFormat: 'Sending report output format…',
    reportFormatApplied: 'Report format switched to {format}',
    setReportFormatFailed: 'Failed to set report output format',
    buildGetSceneModeFail: 'Failed to build scene mode read command',
    buildSetSceneModeFail: 'Failed to build scene mode set command',
    sendingSetSceneMode: 'Sending scene mode...',
    sceneModeApplied: 'Scene mode switched to {scene}',
    buildGetTrackOutputFail: 'Failed to build track output get command',
    trackOutputApplied: 'Track output switched to {state}',
    buildGetAlarmOutputFail: 'Failed to build alarm output get command',
    alarmOutputApplied: 'Alarm output switched to {state}',
    funcZonesTruncated: 'More than {max} zones; only first {max} written',
    funcZonesMaxReached: 'At most {max} zones',
    getDebugOk: 'DEBUG parameters read',
    getDebugFailed: 'Failed to read DEBUG parameters',
    getDebugParseFail: 'Failed to parse DEBUG response',
    getMicroAccumOk: 'Micro accumulation read: {value} frames',
    getMicroAccumLegacy: 'Legacy DEBUG block (12 B), no micro-accum field',
    setDebugOk: 'DEBUG parameters written',
    setDebugFailed: 'Failed to write DEBUG parameters',
    sendingSetHwVersion: 'Writing hardware version…',
    setHwVersionOk: 'Hardware version written: {version}',
    setHwVersionFailed: 'Failed to write hardware version: {message}',
    sendingMicroAccum: 'Writing micro accumulation: {value} frames',
    setMicroAccumOk: 'Micro accumulation saved: {value} frames',
    setMicroAccumFailed: 'Micro accumulation write failed: {value} frames',
    microAccumWriteSkipLegacy: 'Firmware has 12-byte DEBUG block; micro accumulation not written',
    microAccumRetryLegacy: '16-byte DEBUG rejected; retrying legacy 12-byte block',
    sendingSetDebugLegacy: 'Sending legacy DEBUG write (no micro accumulation)',
    setParamsRetrySession: 'Write failed; starting session and retrying once...',
    sessionStartFailBusy:
      'Start session failed: device may already be in session; end session first',
    opNeedSessionFirst: 'Operation failed: start a session first',
    handleConfigError: 'Config response error: {message}',
    configWillReceiveOn: 'Config responses on topics: {topic}, {configTopic}',
    subscribeConfigFailed: 'Subscribe config topic failed: {message}',
    subscribedConfig: 'Subscribed config topic: {topic}',
    errMqttNotConnected: 'Error: MQTT not connected',
    errConfigTopicEmpty: 'Error: config topic not set',
    sendConfigFailed: 'Send config command failed: {message}',
    errFillBrokerFirst:
      'Error: set broker and subscribe topic on the Connect tab first',
    connectingThenSessionStart:
      'Connecting to MQTT; start-session command will be sent when ready...',
    deviceOfflineNeedWait:
      'Device is offline; please wait for the device heartbeat before retrying',
    deviceOfflineSkipAutoFetch:
      'Device is offline; skipped auto parameter fetch (fetch manually once it is online)',
    buildSessionStartFail: 'Failed to build start-session command',
    sendingSessionStart: 'Sending start-session command...',
    buildSessionEndFail: 'Failed to build end-session command',
    sendingSessionEnd: 'Sending end-session command...',
    sessionEndWarn: 'Failed to end session (possible network glitch), saved/loaded parameters are not affected',
    buildGetParamsFail: 'Failed to build read-params command',
    sendingGetParams: 'Sending read-params command...',
    errInvalidParams: 'Error: invalid parameter values',
    buildSetParamsFail: 'Failed to build write-params command',
    sendingSetParams:
      'Sending write-params: height={h} m, tilt={d}°, roll={r}°, azimuth={a}°, fall_th={z} m, micro={m} fr',
    buildGetDebugFail: 'Failed to build read-DEBUG command',
    sendingGetDebug: 'Sending read-DEBUG command...',
    errInvalidDebug: 'Error: invalid DEBUG values',
    buildSetDebugFail: 'Failed to build write-DEBUG command',
    sendingSetDebug: 'Sending write-DEBUG command',
    responseTimeout: 'Config command timeout: {cmd}',
    configAutoRetry: 'Config command response timed out, auto retrying {attempt}/{max}...',
    paramsWriteWarn: 'Algorithm parameters failed to write, but functional zones were saved',
    roomConfigWriteWarn: 'Room size/radar position failed to write, but functional zones were saved',
  },
}
